import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-euro-icon',
  templateUrl: './shopping-euro.component.html'
})
export class ShoppingEuroComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
